import { EVENTS } from "../js/constants";

export default class InteractionEvents {
  /**
   * Creates a tracking instance that handles clicks on accordion buttons and galleries prev/next buttons
   *
   */
  constructor() {
    this.config = {
      selectors: {
        accordionButton: ".Tracking--accordionButton",
        gallery: ".Tracking--imageGallery",
      },
    };

    this.accordionButtons = [
      ...document.querySelectorAll(this.config.selectors.accordionButton),
    ];

    this.galleries = [
      ...document.querySelectorAll(this.config.selectors.gallery),
    ];

    this._init();
  }

  /**
   * binds user events
   *
   * @private
   */
  _init() {
    this.accordionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        InteractionEvents._onClickOnAccordionButton(button);
      });
    });

    this.galleries.forEach((gallery) => {
      gallery.addEventListener(EVENTS.GALLERY_INTERACTION, (event) => {
        InteractionEvents._onGalleryInteraction(event);
      });
    });
  }

  /**
   * Prepare gallery data to be pushed into dataLayer
   *
   * @param {object} event
   * @private
   */
  static _onGalleryInteraction(event) {
    InteractionEvents._dataLayerPush(
      "gallery",
      `${event.detail.number} - ${event.detail.title}`,
      event.detail.direction
    );
  }

  /**
   * handles click on accordion button
   *
   * @param {HTMLElement} accordionButton
   * @private
   */
  static _onClickOnAccordionButton(accordionButton) {
    const accordionButtonState =
      accordionButton.getAttribute("aria-expanded") === "true"
        ? "item expanded"
        : "item minimized";

    // replace() and trim() are needed to remove extra symbols (new lines and spaces) in front and in the end of the strings
    InteractionEvents._dataLayerPush(
      "accordion",
      accordionButton.textContent.replace(/[\n\r]+|[\s]{2,}/g, " ").trim(),
      accordionButtonState
    );
  }

  /**
   * fill out dataLayer object
   *
   * @param {string} eventElement
   * @param {string} contentElement
   * @param {string} interactionType
   * @private
   */
  static _dataLayerPush(eventElement, contentElement, interactionType) {
    window.dataLayer.push({
      event: "Event",
      event_name: `${eventElement}_interaction`,
      [`${eventElement}_interaction`]: {
        interaction_element: contentElement,
        interaction_type: interactionType,

        pp_event_category: "interaction",
        pp_event_action: eventElement,
        pp_event_name: `${contentElement} - ${interactionType}`,
      },
    });
  }
}
